import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonSection() {
  const failures = ['Bloquear y desbloquear', 'Intentar distraerte', 'Pensar en otra cosa', 'Llamar a una amiga (duerme)'];
  const benefits = ['10 minutos de estructura', 'Bajar la ansiedad física', 'Proteger tu dignidad', 'Dormir tranquila'];
  return <section className="py-24 px-6 bg-[#0F0F14]" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-21">
          {/* Failed Solutions */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="glass-card p-8 rounded-2xl border-l-4 border-l-[#E8636F]/50" data-id="element-22">
            <h3 className="text-xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-23">
              <span className="text-[#E8636F]" data-id="element-24">❌</span> Lo que ya intentaste
            </h3>
            <ul className="space-y-6" data-id="element-25">
              {failures.map((item, index) => <li key={index} className="flex items-center gap-4 text-[#A8A8B3] line-through decoration-[#E8636F]/50" data-id="element-26">
                  <XIcon className="w-5 h-5 text-[#E8636F]/60" data-id="element-27" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* RU Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="glass-card p-8 rounded-2xl border-l-4 border-l-[#5BB5A2] bg-white/[0.02]" data-id="element-28">
            <h3 className="text-xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-29">
              <span className="text-[#5BB5A2]" data-id="element-30">✅</span> El Ritual de Urgencia
            </h3>
            <ul className="space-y-6" data-id="element-31">
              {benefits.map((item, index) => <li key={index} className="flex items-center gap-4 text-white font-medium" data-id="element-32">
                  <div className="w-5 h-5 rounded-full bg-[#5BB5A2]/20 flex items-center justify-center" data-id="element-33">
                    <CheckIcon className="w-3 h-3 text-[#5BB5A2]" data-id="element-34" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-16" data-id="element-35">
          <h3 className="text-2xl md:text-4xl font-heading font-bold text-white" data-id="element-36">
            Tú no necesitas motivación. <br data-id="element-37" />
            Necesitas <span className="text-gradient" data-id="element-38">estructura</span>.
          </h3>
        </motion.div>
      </div>
    </section>;
}